/* eslint-disable */
export default {
  flipHeader: 'Flip call to...',
  flip: 'Flip',
  complete: 'Complete Flip',
} as const;

// @key: @#@"flipHeader"@#@ @source: @#@"Flip Call to..."@#@
// @key: @#@"flip"@#@ @source: @#@"Flip"@#@
// @key: @#@"complete"@#@ @source: @#@"Complete Flip"@#@
